/**
 * This file is a plugin for the "Config" plugin
 * Reference info: https://confluence.genband.com/display/KSDK/Plugins
 */
import pluginInterface from './interface'

/**
 * Config Plugin
 *
 * @method configImplementation
 * @return {Object} An instance of the "Config" plugin.
 */

// yarn lint:docs complains if this isn't defined in a plugin.
/**
 * @module config
 */
export default function configImplementation () {
  return {
    // Interface Components:
    name: pluginInterface.name,
    capabilities: ['config'],
    api: pluginInterface.api,
    reducer: pluginInterface.reducer
  }
}
